module.exports = __webpack_public_path__ + "media/images/lb/132-7ec0f7f7c1cb1444eec31dc0ace65a99.svg";